import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, Globe, Menu, X } from "lucide-react";
import { navLinks } from "../mock";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#07080d]/90 backdrop-blur-md border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        {/* Logo */}
        <a href="/" className="flex items-center gap-2 group">
          <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#3b59ff] to-[#1c3df5] flex items-center justify-center">
            <div className="w-3 h-3 rounded-full bg-white/95"></div>
          </div>
          <span className="font-display font-bold text-xl tracking-tight">Northwind</span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((nav) => (
            <div
              key={nav.label}
              className="relative"
              onMouseEnter={() => setOpenMenu(nav.label)}
              onMouseLeave={() => setOpenMenu(null)}
            >
              <button className="flex items-center gap-1 px-4 py-2 text-[15px] text-white/85 hover:text-white transition-colors">
                {nav.label}
                <ChevronDown
                  size={14}
                  className={`transition-transform ${openMenu === nav.label ? "rotate-180" : ""}`}
                />
              </button>
              {openMenu === nav.label && (
                <div className="absolute top-full left-1/2 -translate-x-1/2 pt-3 w-[340px]">
                  <div className="bb-card rounded-2xl p-3 shadow-2xl shadow-black/60">
                    {nav.items.map((it) => (
                      <a
                        key={it.title}
                        href="#"
                        className="flex flex-col px-4 py-3 rounded-xl hover:bg-white/5 transition-colors"
                      >
                        <span className="text-white font-medium text-[15px]">{it.title}</span>
                        <span className="text-xs text-white/55 mt-0.5">{it.desc}</span>
                      </a>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </nav>

        {/* CTA */}
        <div className="flex items-center gap-2">
          <Link
            to="/login"
            className="hidden md:inline-flex items-center px-4 py-2 text-[15px] text-white/85 hover:text-white border border-white/15 rounded-lg hover:border-white/30 transition-all"
          >
            Log in
          </Link>
          <Link
            to="/signup"
            data-testid="header-demo-cta"
            className="hidden md:inline-flex items-center px-4 py-2 text-[15px] text-white bg-white/[0.06] hover:bg-white/10 border border-white/10 rounded-lg transition-all"
          >
            Free Demo
          </Link>
          <Link
            to="/signup"
            className="inline-flex items-center px-4 lg:px-5 py-2 text-[15px] font-medium text-white bb-blue rounded-lg transition-all"
          >
            Open Account
          </Link>
          <button className="hidden md:inline-flex w-9 h-9 items-center justify-center text-white/70 hover:text-white">
            <Globe size={18} />
          </button>
          <button
            className="lg:hidden ml-1 w-9 h-9 inline-flex items-center justify-center text-white"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="lg:hidden bg-[#07080d] border-t border-white/5 px-6 py-4 max-h-[80vh] overflow-y-auto">
          {navLinks.map((nav) => (
            <details key={nav.label} className="py-2 border-b border-white/5">
              <summary className="flex items-center justify-between cursor-pointer py-2 text-white">
                {nav.label}
                <ChevronDown size={16} />
              </summary>
              <div className="pl-2 pb-2">
                {nav.items.map((it) => (
                  <a key={it.title} href="#" className="block py-2 text-sm text-white/70">
                    {it.title}
                  </a>
                ))}
              </div>
            </details>
          ))}
        </div>
      )}
    </header>
  );
};

export default Header;
